module.exports = __webpack_public_path__ + "img/gd.c0bf1531.svg";